
export const resetTimeZone = (date:string | Date) => {
    return new Date(date).toISOString();
};